<template>
  <v-app id="all" :class="{ bookStyle: bookStyle }" v-if="app_ready">
    <div v-if="bookStyle" class="book2024-discontinued-banner">
      2024 解答之书已停止贩售，已购买的会员仍然可以继续使用。
    </div>
    <NavBar
      :navlogined="afterLogin"
      :class="{ 'book-nav-offset': bookStyle }"
    />
    <v-main>
      <router-view />
    </v-main>
    <Footer v-if="!isLandingPage" />
    <Toast />
    <loadingAnimation v-if="loading || loading_force"></loadingAnimation>
    <Warnging />
    <Message />
    <AlreadyWriteVue />
    <Notice />
    <ImageNotice />
    <Registration v-if="showRegistation" />
    <NewMoonCTAVue
      v-if="todayIsNewMoon && showNewMoonNotice"
      v-show="!excludeNewMoonCTA.includes(currentRouteName)"
    ></NewMoonCTAVue>
    <SelectAstrolabePopup />
    <ServiceAd
      ref="serviceAd"
      service-id="astro-calendar-2026"
      :mobileImage="serviceAdImage.mobile"
      :largeImage="serviceAdImage.large"
      productCode="Calendar2026"
      :isLoggedIn="afterLogin"
      :shouldHide="isHideServiceAd"
      @close="onServiceAdClose"
    />
    <AstroCalendarNoticeDialog
      class="lockScroll"
      @close="showAstroCalendarNoticeDialog = false"
      v-if="showAstroCalendarNoticeDialog"
    />
  </v-app>
</template>

<script>
import Warnging from "@/components/Warning.vue";
import Message from "@/components/Message";
import Toast from "@/components/Toast.vue";
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import loadingAnimation from "./components/LoadingAnimation";
import jwt from "jsonwebtoken";
import Registration from "./components/Registration.vue";
import AlreadyWriteVue from "./components/月亮日記/AlreadyWrite.vue";
import NewMoonCTAVue from "./components/月亮日記/NewMoonCTA.vue";
import Notice from "./components/Notice.vue";
import ImageNotice from "./components/ImageNotice.vue";
import SelectAstrolabePopup from "./components/SelectAstrolabePopup.vue";
import AstroCalendarNoticeDialog from "./components/共時曆/AstroCalendarNoticeDialog.vue";
import ServiceAd from "./components/ServiceAd.vue";
import moment from "moment";
export default {
  name: "App",
  //vue-meta設置
  metaInfo() {
    return {
      title: "ASTRORG 星学会展示网站",
      meta: [
        {
          name: "description",
          content: `ASTRORG 星学会展示网站，聚焦于客制化星盘服务展示、产品概念说明、合作案例示意与商业化模型介绍，仅供业务开发与合作评估参考。`,
        },
        {
          name: "Keywords",
          content: `ASTRORG,星学会,展示网站,占星,星盘,合作提案,产品展示`,
        },
        {
          name: "og:image",
          property: "og:image",
          content:
            this.$route.fullPath.indexOf("book") > -1
              ? `https://i.imgur.com/5n5gMaQ.jpg`
              : `https://i.imgur.com/eB82Sl9.jpg`,
        },
        {
          name: "twitter:image",
          property: "twitter:image",
          content:
            this.$route.fullPath.indexOf("book") > -1
              ? `https://i.imgur.com/5n5gMaQ.jpg`
              : `https://i.imgur.com/eB82Sl9.jpg`,
        },
      ],
    };
  },
  data() {
    return {
      app_ready: false,
      excludeNewMoonCTA: [
        "NewMoon",
        "MoondayCreate",
        "MoondayEdit",
        "MoondayNote",
      ],
      showAstroCalendarNoticeDialog: false,
      serviceAdImage: {
        large: require("@/assets/new_product_ad/astroCalendar_large.svg"),
        mobile: require("@/assets/new_product_ad/astroCalendar_mobile.svg"),
      },
    };
  },
  components: {
    loadingAnimation,
    NavBar,
    Footer,
    Toast,
    Warnging,
    Message,
    Registration,
    AlreadyWriteVue,
    NewMoonCTAVue,
    Notice,
    ImageNotice,
    SelectAstrolabePopup,
    AstroCalendarNoticeDialog,
    ServiceAd,
  },

  created() {
    this.init();
    console.log("v20260402", process.env.NODE_ENV);
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    loading() {
      return this.$store.state.loading;
    },
    loading_force() {
      return this.$store.state.loading_force;
    },
    afterLogin() {
      return this.$store.state.afterLogin;
    },
    showRegistation() {
      return this.$store.state.showRegistation;
    },
    todayIsNewMoon() {
      return this.$store.getters.todayIsNewMoon;
    },
    showNewMoonNotice() {
      //預設true，要關掉才會變false
      return this.$store.getters.showNewMoonNotice;
    },
    bookStyle() {
      const bookRegex = /^\/book202[4-7]/;
      return bookRegex.test(this.$route.path);
    },
    isHideServiceAd() {
      if (this.$route.name === "member-create") return true;
      return this.$store.state?.userData?.CalendarInfo?.IsOwned2026 === true;
    },
    isLandingPage() {
      return this.$route.name === "index";
    },
  },
  methods: {
    init() {
      // TODO: 改為判斷如果是運勢書 URL要是運勢書首頁
      this.$store.commit("set_app_return_url", document.location.origin);

      //測試地理位置
      // console.log(this.$API.Encrypt("U7a91feba19cd0f6cef87cd70e1cc96a3"));
      //判斷是不是Line進來
      this.enter_method_deal();
      //判斷
      if (typeof Storage == "undefined") {
        alert("您的瀏覽器不支援 Web Storage，請更換瀏覽器否則無法登入喔！");
      }
      //存到undefined
      if (
        window.localStorage.getItem("AC") == "375B98AFE9C3475A6B7605EB109A6FCC"
      ) {
        this.logout();
      }
      // [CN] 測試用帳號，PlatformId：demo
      if (true) {
        let AC = this.$API.Encrypt("demo");
        localStorage.setItem("AC", AC);
        localStorage.setItem("loginMethods", "Line");
        localStorage.setItem(
          "imageUrl",
          "https://img2.baidu.com/it/u=2277530240,1500609752&fm=253&fmt=auto&app=138&f=JPEG?w=475&h=475"
        );
        localStorage.setItem("haveNoData", false);
      }

      if (
        //有完成第三方登入(FB、GOOGLE)取得UID，進行我方登入
        window.localStorage.getItem("AC") &&
        window.localStorage.getItem("loginMethods")
      ) {
        this.$store.commit("updateLoginStatus", true);
        this.$store.commit(
          "updateHeadImage",
          window.localStorage.getItem("imageUrl")
        );
        this.loginHandler();
      } else {
        //進行LINE登入判斷
        this.$store.commit("updateLoginStatus", false);
        //清除上一次的token
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("AC");
        if (window.location.href.indexOf("afterLineBack") > -1) {
          this.Line_loginHandler();
        } else {
          this.app_ready = true;
          this.initBookStatus();
          window.localStorage.removeItem("toWhere");
        }
      }
    },
    Line_loginHandler() {
      //Line處理開始
      let lineData = {
        grant_type: "authorization_code",
        redirect_uri: this.$store.state.app_return_url, //正式
        client_id: process.env.VUE_APP_client_id, // 正式
        client_secret: process.env.VUE_APP_client_secret, //正式
        code: window.location.search.split("code=")[1].split("&")[0],
      };
      let passData = this.Qs.stringify(lineData);
      this.$API
        .Line_LoginAuth(passData)
        .then((data) => {
          window.localStorage.setItem("LT", data.access_token);
          let email = jwt.decode(data.id_token).email;
          window.localStorage.setItem("email", email);
          this.$API.Get_Line_data().then((response) => {
            let AC = this.$API.Encrypt(response.userId);
            window.localStorage.setItem("before", response.userId);
            if (!response.userId) {
              window.location = this.$route.meta.logoutDirectIndexPage || "/";
            }
            window.localStorage.setItem("imageUrl", response.pictureUrl);
            this.$store.commit("updateHeadImage", response.pictureUrl);
            localStorage.setItem("loginMethods", "Line");
            window.localStorage.setItem("AC2", AC);
            window.localStorage.setItem("AC", AC);
            //進行登入
            this.loginHandler();
          });
        })
        .catch(() => {});
    },
    loginHandler() {
      try {
        //我方登入

        const account = window.localStorage.getItem("AC");
        this.$API.Login(account).then(async (data) => {
          window.localStorage.setItem("login_status", true);
          this.$store.commit(
            "updateHeadImage",
            window.localStorage.getItem("imageUrl")
          );
          this.$store.commit("updateLoginStatus", true);
          if (data.Data == null) {
            //沒有得到token，因此進行註冊
            window.localStorage.setItem("haveNoData", true);
            this.app_ready = true;
            this.$router.push({ path: "/member-create" });
          } else {
            //跳轉到該去的地方(2023/12/17)
            let directionPath = window.localStorage.getItem("directionPath");
            if (directionPath) {
              this.$router.replace(directionPath);
              window.localStorage.removeItem("directionPath");
            }

            //得到token，將token保存，並呼叫取得會員資料
            window.localStorage.setItem("haveNoData", false);
            window.localStorage.setItem("token", data.Data.Token);
            this.$store.commit("set_token", data.Data.Token);
            window.localStorage.setItem(
              "loginIndex",
              data.Data.MemberDetail.MemberId
            );
            window.localStorage.setItem("loginIndex", data.Data.MemberId);

            this.$store.commit("set_userData", data.Data.MemberDetail);
            this.$store.commit(
              "set_hasCalendarNotify",
              data.Data.MemberDetail?.CalendarInfo?.IsNotifyEnabled || false
            );

            let self = this.$store.getters.SELF_OBJ;
            const res = await this.$API.Get_AstrolabeFile(self.AstrolabeFileId);
            this.$store.commit("set_nowUserData", res.Data);

            //占星小舖初始化
            await this.initStore();

            //檢查今天是不是新月
            this.checkTodayIsNewMoon();

            //初始化運勢書解鎖狀況
            await this.initBookStatus();

            //真正意義上的初始化完成，開始渲染組件
            this.app_ready = true; //真的有獲取userData，開始渲染子組件

            //等 DOM 渲染後再檢查 ServiceAd 是否顯示，以決定 NewMoonNotice 時機
            this.$nextTick(() => {
              this.initNewMoonNotice();
            });

            if (!this.$store.state.userData) {
              //解析失敗 須重置
              this.logout();
            }
            this.popEventHandler(data);
          }
        });
      } catch (err) {
        this.app_ready = true;
        console.error(err);
      }
    },
    //進入點處理(判斷是否為LINE瀏覽器開啟，但20230506已全面改為openExternalBrowser)
    enter_method_deal() {
      let url = window.location.search;
      if (
        url.indexOf("openExternalBrowser") > -1 &&
        window.localStorage.getItem("loginMethods") != "Line"
      ) {
        //藉由圖文選單的openExternalBrowser進入，但loginMethods不是LINE
        this.logout(false);

        //強制觸發LINE登入
        this.$store.state.LoginOutSide = false;
        let url = "https://access.line.me/oauth2/v2.1/authorize?";
        url += "response_type=code";
        url += "&client_id=" + process.env.VUE_APP_client_id; //正式
        url += "&redirect_uri=" + this.$store.state.app_return_url; //正式
        url += "&state=afterLineBack";
        url += "&scope=openid%20profile";
        // %20email
        return (window.location.href = url);
      }
      let queryArry = url.split("&");
      if (queryArry[0] == "?source=line") {
        window.localStorage.setItem("source", "Line");
        window.localStorage.setItem("FromNode", "Line");
      }
      // Line瀏覽器判定
      if (
        this.$route.query.source === "Line" ||
        window.localStorage.getItem("source") === "Line"
      ) {
        this.$store.state.FromLineWebApp = true;
      }
    },
    logout(refresh = true) {
      window.localStorage.removeItem("login_status");
      window.localStorage.removeItem("AC");
      window.localStorage.removeItem("imgUrl");
      window.localStorage.removeItem("haveNoData");
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("LT");
      if (refresh) {
        window.location = this.$route.meta.logoutDirectIndexPage || "/";
      }
    },
    async initStore() {
      try {
        let res = await this.$API.GET_Products();
        this.$store.commit("set_service_list", res.data.Data);
      } catch (err) {
        console.error(err);
      }
    },
    async checkTodayIsNewMoon() {
      try {
        let res = await this.$API.GET_MoonDayCalendar();
        this.$store.commit("setTodayIsNewMoon", res.data.Data);
      } catch (err) {
        console.error(err);
      }
    },
    initNewMoonNotice() {
      const adVisible = this.$refs.serviceAd && this.$refs.serviceAd.visible;
      if (!adVisible) {
        this.$store.commit("setShowNewMoonNotice", true);
      }
      // 有廣告顯示時，等 @close 事件觸發 onServiceAdClose 再顯示
    },
    onServiceAdClose() {
      this.$store.commit("setShowNewMoonNotice", true);
    },
    async initBookStatus() {
      let _book2024_productionList = new Map();
      let _book2024_buyAllObj = null;
      try {
        let res = await this.$API.GET_BOOKLIST();
        let bookObj = res.data.Data.find((item) => item.BookID == 1) || {};
        bookObj.ProductList.forEach((item) => {
          _book2024_productionList.set(item.Code, item);
          if (item.Code == "All") {
            _book2024_buyAllObj = item;
          }
        });
      } catch (err) {
        console.error("Failed to get book list", err);
        throw err;
      }

      //判斷解鎖列表
      let userUnlockList = [];
      if (this.$store.state.afterLogin) {
        if (this.$store.state.userData.BookMap) {
          userUnlockList = this.$store.state.userData.BookMap["2024"]
            .ConstellationList;
        }
      }

      let _productList = this.$Astro.map((astro, index) => {
        let productObj = _book2024_productionList.get(astro.en) || {};
        let isUnlock = this.$store.state.afterLogin
          ? userUnlockList.includes(astro.en)
          : false;
        return {
          ...productObj,
          ...astro,
          isUnlock,
        };
      });
      if (_book2024_buyAllObj) {
        _book2024_buyAllObj.isUnlock = userUnlockList.length >= 12;
        _productList.push(_book2024_buyAllObj);
      }
      this.$store.commit("set_book2024_list", _productList);
    },
    giverGiftHandler() {
      //如果已經在禮物盒頁面，就不再彈出
      if (this.$route.name == "member-giftBox") return;
      this.$imageNotice({
        imageIdx: 1,
        title: "收到禮物囉",
        okText: "查看我的禮物盒",
        desc: `恭喜！您收到朋友贈送給你的禮物喔！`,
        okEvent: () => {
          this.$router.push({ name: "member-giftBox" });
        },
        cancelText: "稍後查看",
      });
    },
    enableGiftSuccessHandler(gift, AstrolabeFileId) {
      let desc = "";
      if (gift.GiverMemberId) {
        desc = `已成功啟用${gift.GiverName} (ID:${gift.GiverMemberId}) 贈送給你的「${gift.ProductName}」禮物喔！`;
      } else {
        desc = `已成功啟用「${gift.ProductName}」禮物喔！`;
      }
      this.$imageNotice({
        imageIdx: 1,
        title: `成功啟用${gift.ProductName}`,
        desc,
        okText: `前往${gift.ProductName}`,
        okEvent: () => {
          switch (gift.ProductName) {
            case "宮位解讀":
              this.$API.Get_AstrolabeFile(AstrolabeFileId).then((data) => {
                this.$store.commit("set_nowUserData", data.Data);
                return this.$router.push("/astrolabe");
              });
              break;
            case "推運功能":
              return this.$router.push("/timelineAstrolabe");
            case "月亮日記":
              return this.$router.push("/moonday-list");
            default:
              return this.$router.push("/book2024/my");
          }
        },
        cancelText: "返回至當前頁面",
        cancelEvent: () => {
          window.location.reload();
        },
      });
    },
    //所有彈跳窗事件
    async popEventHandler(data) {
      // 共時曆通知 (不與其他通知衝突)
      const today = moment().format("YYYY-MM-DD");

      let ShowCalendarNotify =
        localStorage.getItem("astroCalendarNotice") !== today;
      // process.env.NODE_ENV === "production"
      //   ? localStorage.getItem("astroCalendarNotice") !== today
      //   : true;

      if (
        data.Data.MemberDetail?.CalendarInfo?.IsOwned2026 &&
        data.Data.MemberDetail?.CalendarInfo?.IsNotifyEnabled &&
        ShowCalendarNotify
      ) {
        //取得共時歷解讀
        try {
          let todayInterpretation = await this.$API.GET_CALENDAR_INTERPRETATION(
            moment().format("YYYY-MM-DD")
          );
          this.$store.commit(
            "set_calendarInterpretation",
            todayInterpretation.data.Data
          );
          this.showAstroCalendarNoticeDialog = true;
        } catch (err) {
          console.error("calendarInterpretation fetch error:");
        }
      }

      //歸戶判斷(2023/04/09新增) -> 暫時for已註冊用戶
      let isImport = window.location.href.indexOf("isImport") > -1;
      if (
        isImport ||
        (!data.Data.MemberDetail.HasAccount &&
          !data.Data.MemberDetail.NoNeedToRemind)
      ) {
        setTimeout(() => {
          this.$store.commit("update_showRegistation", true);
        }, 1000);
      } else if (window.location.href.indexOf("enableGiftSuccess=true") > -1) {
        // 判斷是否啟用禮物成功
        let targetGift = JSON.parse(localStorage.getItem("targetGift"));
        let AstrolabeFileId = localStorage.getItem("targetGift_id");
        setTimeout(() => {
          this.enableGiftSuccessHandler(targetGift, AstrolabeFileId);
        }, 1000);
      } else {
        // 以下為正常流程，需要跳的Dialog要全跳

        //判斷是不是有收到禮物
        if (data.Data.MemberDetail.HasUnenabledGifts) {
          setTimeout(() => {
            this.giverGiftHandler();
          }, 500);
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "./scss/all.scss";

#all {
  background-color: #19112b;
  overflow: hidden;
  color: #ffffff;
  &.bookStyle {
    --book-banner-height: 44px;
    background: linear-gradient(0deg, #19112b 0%, #1f1535 51.5%, #19112b 100%);

    @include mobile {
      --book-banner-height: 64px;
    }
  }
}

.bookStyle .third-title {
  display: inline;
  background-color: #d3409d;
  padding: 0 4px;
  border-radius: 4px;
}

.book2024-discontinued-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 110;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background: oklch(0.28 0.06 70);
  color: oklch(0.88 0.08 85);
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  font-family: "Noto Sans TC";
}

.book-nav-offset .nav {
  top: var(--book-banner-height, 44px);
}

.book-nav-offset .mobile__navbar {
  top: var(--book-banner-height, 44px);
}

.book-nav-offset .nav-space {
  height: calc(95px + var(--book-banner-height, 44px));

  @include laptop {
    height: calc(60px + var(--book-banner-height, 44px));
  }
}

.custom-container-xl {
  max-width: 1472px;
  margin: 0 auto;
  padding: 0 16px;
}

.custom-container {
  max-width: 1056px;
  margin: 0 auto;
  padding: 0 16px;
}

.custom-row {
  display: flex;
}

.custom-bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  box-shadow: none;
  background-color: rgba(255, 255, 255, 0.2);
  margin: 0 6px;
  @include mobile {
    width: 6px;
    height: 6px;
  }
}

.custom-bullet-active {
  width: 56px;
  background-color: $theme-color-1;
  box-shadow: 0 0 8px rgba($theme-color-1, 0.4);
  @include mobile {
    width: 32px;
  }
}

.v-dialog {
  margin: 0 !important;
}

.v-overlay .v-overlay__scrim {
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
}

.picker {
  font-family: "Noto Sans TC", "Microsoft JhengHei", "Helvetica", sans-serif;
  background-color: #1f1535 !important;

  .v-picker__body {
    background-color: #1f1535 !important;
  }

  &.date-picker {
    flex-shrink: 0;
    min-height: 420px;
    .v-date-picker-title {
      .v-date-picker-title__year {
        color: rgba(255, 255, 255, 0.5);
        font-size: 16px;
        letter-spacing: 1.28px;
      }

      .v-date-picker-title__date {
        color: rgba(255, 255, 255, 0.8);
        font-size: 28px;
        font-weight: bold;
        letter-spacing: 1.6px;
      }
    }

    .v-date-picker-header .v-date-picker-header__value button {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.25;
      letter-spacing: 1.28px;
      color: #ffffff !important;
    }
  }

  &.time-picker {
    .v-time-picker-title__time .v-picker__title__btn,
    .v-time-picker-title__time span {
      color: rgba(255, 255, 255, 0.8);
      font-size: 60px;
      font-weight: bold;
      letter-spacing: 4.8px;
    }
    .v-picker__title__btn:not(.v-picker__title__btn--active) {
      opacity: 0.3;
    }

    .v-time-picker-title__ampm {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      font-weight: bold;
      line-height: 1.25;
      letter-spacing: 1.28px;
    }

    .v-time-picker-clock {
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      background-color: #2a1b4a;
    }
    .v-time-picker-title__ampm .v-picker__title__btn {
      font-size: 0px;
      &:nth-of-type(1):after {
        content: "上午";
        font-size: 20px;
      }
      &:nth-of-type(2):after {
        content: "下午";
        font-size: 20px;
      }
    }
  }
}

.select {
  &.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
    > .v-input__control
    > .v-input__slot {
    box-shadow: none !important;
    padding: 0;
  }

  &.v-text-field.v-text-field--solo .v-input__control {
    min-height: 0;
  }

  .v-select__selections {
    color: $secondary-color-1 !important;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 1.6px;
    @include mobile {
      font-size: 16px;
      line-height: 1;
      letter-spacing: 0.56px;
    }
  }
}

@media only screen and (min-width: 1264px) {
  .hidden-laptop-up {
    display: none !important;
  }
}

@media only screen and (max-width: 1263px) {
  .hidden-laptop-down {
    display: none !important;
  }
}

@media only screen and (min-width: 960px) {
  .hidden-pad-up {
    display: none !important;
  }
}

@media only screen and (max-width: 959px) {
  .hidden-pad-down {
    display: none !important;
  }
}

@media only screen and (min-width: 577px) {
  .hidden-mobile-up {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  .hidden-mobile-down {
    display: none !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@keyframes fade {
  from {
    opacity: 1;
    display: inline;
    bottom: 20px;
  }
  15% {
    bottom: 10px;
  }
  30% {
    bottom: 20px;
  }
  45% {
    bottom: 10px;
  }
  60% {
    bottom: 20px;
  }
  75% {
    bottom: 10px;
  }
  90% {
    bottom: 20px;
    opacity: 0.8;
  }
  to {
    display: none;
    opacity: 0;
  }
}
.v-application--wrap:has(.lockScroll) {
  height: 100vh !important;
  overflow: hidden !important;
}
</style>
